import { IdentityProvider } from "../login.repository";

export class SsoChooseRoleService {

	/*@ngInject*/
    constructor(
        private $location: ng.ILocationService
    ) {
    }

    execute(provider?: IdentityProvider) {
        let params = { provider: provider ?? IdentityProvider.Esia };
        this.prepareParams(params);
	    this.$location.path(`/authorize/sso/choose-role`).search(params);
    }

    private prepareParams(options) {
        let searchParams = new URLSearchParams(window.location.search);

        let responseType = searchParams.get('response_type');
        if (responseType) {
            options.response_type = responseType;
        }

        let redirectUri = searchParams.get('redirect_uri');
        if (redirectUri) {
            options.redirect_uri = redirectUri;
        }

        let clientId = searchParams.get('client_id');
        if (clientId) {
            options.client_id = clientId;
        }

        let scope = searchParams.get('scope');
        if (scope) {
            options.scope = scope;
        }

        let state = searchParams.get('state');
        if (state) {
            options.state = state;
        }

        let codeChallenge = searchParams.get('code_challenge');
        if (codeChallenge) {
            options.code_challenge = codeChallenge;
        }

        let codeChallengeMethod = searchParams.get('code_challenge_method');
        if (codeChallengeMethod) {
            options.code_challenge_method = codeChallengeMethod;
        }

        let acrValues = searchParams.get('acr_values');
        if (acrValues) {
            options.acr_values = acrValues;
        }
    }
}
